module.exports = __webpack_public_path__ + "img/chr_ts_21_2.1d3c3c09.png";